
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addMadel from "./components/add-madel.vue";
import { getSmsComboes } from "@/api/api-basic-sms";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-madel": addMadel
  }
})
export default class MessagePrice extends Vue {
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    // globalPageIndex: 1,
    // globalPageSize: 10,
    // globalSearch: ""
  };

  private addMadel: objAny = {};
  private ruleInline = {};
  private tableList: object[] = [{}];
  private tableColumns: object[] = [
    {
      title: i18n.t("messagePrice.number"),
      key: "number",
      minWidth: 80
    },
    {
      title: i18n.t("messagePrice.price"),
      key: "price",
      minWidth: 120
    },
    {
      title: i18n.t("messagePrice.contactPhone"),
      key: "contactPhone",
      minWidth: 140
    },
    {
      title: i18n.t("messagePrice.status"),
      key: "statusDesc",
      minWidth: 120
    },
    {
      title: i18n.t("remark"),
      key: "remark",
      minWidth: 140
    },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getSmsComboes(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  public addClick() {
    this.addMadel.open({}, "add");
  }
  public updataClick(item: objAny) {
    this.addMadel.open(item, "updata");
  }
  public colseClick(item: objAny) {
    this.addMadel.open(item, "status");
  }

  mounted() {
    this.$nextTick(() => {
      this.addMadel = this.$refs.addMadel;
    });
    this.getTableList();
  }
}
